// extracted by mini-css-extract-plugin
module.exports = {"root":"_root__ZBfoB"};